import React from "react";
import HighlightCompanyName from "./HighlightCompanyName";
const BenefitIcon = ({ type }) => {
  const icons = {
    growth: "↗",
    learning: "◈",
    team: "◎",
    innovation: "✦",
    impact: "◉",
    ownership: "◌",
  };

  return (
    <span className="benefit-card__icon" aria-hidden="true">
      {icons[type] || "✦"}
    </span>
  );
};

const Benefits = ({ benefits }) => {
  return (
    <section className="benefits">
      <div className="careers-container">
        <div className="section-heading">
          <span className="section-heading__eyebrow">WHAT YOU CAN EXPECT</span>

          <h2 className="section-heading__title">
            A workplace designed for growth.
          </h2>

          <p className="section-heading__description">
            <HighlightCompanyName text="We want every person at Belageri Technologies to have opportunities to learn, contribute, and grow." />
          </p>
        </div>

        <div className="benefits__grid">
          {benefits.map((benefit) => (
            <article className="benefit-card" key={benefit.title}>
              <BenefitIcon type={benefit.icon} />

              <div className="benefit-card__content">
                <h3>{benefit.title}</h3>

                <p>{benefit.description}</p>
              </div>

              <span className="benefit-card__arrow" aria-hidden="true">
                ↗
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
